module.exports = __webpack_public_path__ + "static/media/img_19.c177e6dd.png";